import { render, staticRenderFns } from "./StatisticsAccessByPreferenceDevice.vue?vue&type=template&id=32a5e0ce&"
import script from "./StatisticsAccessByPreferenceDevice.vue?vue&type=script&lang=js&"
export * from "./StatisticsAccessByPreferenceDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports